import React from 'react'
import { Trans } from 'react-i18next'
import { Typography } from '@creditas-ui/react'

const TitleWithDocument = () => (
  <div data-testid="title-with-document">
    <Trans
      i18nKey="pages:password.identify.headings.page_title"
      components={[
        <Typography
          key="bold-text"
          color="neutral.90"
          variant={{ _: 'bodyMdBold', '4xl': 'headingLgBold' }}
          component="span"
        />,
        <Typography
          key="regular-text"
          color="neutral.90"
          variant={{ _: 'bodyMdRegular', '4xl': 'headingLgRegular' }}
          component="span"
        />,
      ]}
    />
  </div>
)

export default TitleWithDocument
